<template>
	<div class="middle"   :style="loginDivCSS">
		<div>
			<p id="title">{{this.Config.APP_NAME}}</p>
			<p id="subTitle">XDO {{this.Config.APP_VERSION}}</p>
		</div>
		<div id="loginContainer">
			<div id="loginDiv">
				<h3 style="font-weight: bold;">用户登录</h3>
				<a-input v-model="loginForm.userName" 
				:allowClear="true" style="margin-top:0.625rem;font-size: 0.6875rem;"  
				:placeholder="tipMsg.userTip" ref="nameInput"
				 :disabled="tipMsg.loadingFlag">
					 <a-icon slot="prefix" type="user" />
				</a-input>
				<a-input-password  v-model="loginForm.password"  ref="passwordInput"
				 :allowClear="true" style="margin-top: 1rem;font-size: 0.6875rem;" 
				  :placeholder="tipMsg.passwordTip" :disabled="tipMsg.loadingFlag">
					<a-icon slot="prefix" type="lock" />
				</a-input-password >
				<div id="captchaDiv">
					<a-input v-model="loginForm.code" :allowClear="true"   ref="codeInput" 
					style="margin-top: 1rem;width:11.5rem;font-size: 0.6875rem;"  :placeholder="tipMsg.captchaTip" :disabled="tipMsg.loadingFlag">
						<a-icon slot="prefix" type="safety" />
					</a-input>
					<img :src="tipMsg.captchaUrl" style="cursor:pointer;width:6.5rem;height:1.5rem;margin-top: 0.875rem" title="点击图片更换验证码" @click="changeCaptcha()"/>
				</div>
				
				<a-button icon="login" block  type="primary" style="margin-top: 1.25rem;font-size: 0.75rem;" @click="doLogin" :loading="tipMsg.loadingFlag">
				{{tipMsg.loginBtnTip}}
				</a-button>
			</div>
		</div>
		<div>
			<p id="copyright">{{this.Config.COPYRIGHT}}</p>
		</div>
	</div>
</template>
<script>
	export default {
		
		
		data(){
			var self = this;
			window.addEventListener('keydown', self.keyDown);
			
			return{
				loginDivCSS:{
					backgroundImage: "url(" + require('../assets/bg1.jpg') + ")",
				},
				loginForm:{
					userName:'',
					password:'',
					code:'',
				},
				tipMsg:{
					loginBtnTip:'登 录',
					loadingFlag:false,
					captchaUrl:this.Api.getLastUrl(this.Api.USER_CAPTCHA_URL),
					userTip:'请输入用户名',
					passwordTip:'请输入密码',
					captchaTip:'请输入验证码',
				},
			}
		},
		created(){
			
		},
		destroyed(){
			window.removeEventListener('keydown', this.keyDown);
		},
		methods:{
			keyDown(e) {
				if (e.keyCode == 13) {
						this.doLogin();
				}
      },
			changeCaptcha:function(){
				var urlStr = this.Api.getLastUrl(this.Api.USER_CAPTCHA_URL)+'?'+Math.random();
				this.tipMsg.captchaUrl = urlStr;

			},
			doValidate:function(){
				if(this.loginForm.userName.length == 0){
					 this.$message.error(this.tipMsg.userTip);
					 this.$nextTick((x)=>{
						 this.$refs.nameInput.focus();
					 });
					 return false;
				}
				if(this.loginForm.password.length == 0){
					 this.$message.error(this.tipMsg.passwordTip);
					 this.$nextTick((x)=>{
					 	 this.$refs.passwordInput.focus();
					 });
					 return false;
				}
				if(this.loginForm.code.length == 0){
					this.$message.error(this.tipMsg.captchaTip);
					this.$nextTick((x)=>{
						 this.$refs.codeInput.focus();
					});
					return false;
				}
				return true;
			},
			doLogin:function(){
				if(this.doValidate()){
					this.tipMsg.loadingFlag = true;
					this.tipMsg.loginBtnTip = '登录中...'; 
					let url = this.Api.getLastUrl(this.Api.USER_LOGIN_URL);
					this.Api.fetchPostWithForm(url,this.loginForm).then((data)=>{
						let code = data.data.code;
						let result = data.data.result;
						let msg = data.data.message;
						if(code == this.Api.HTTP_OK_CODE){
							this.resetLogin(true);
							this.Config.saveUseLocal(result);
							this.Config.goHome();
							window.removeEventListener('keydown', this.keyDown);
						}else{
							this.resetLogin(false);
							this.$message.error(msg);
						}
					}).catch((error)=>{
						this.resetLogin(false);
					});
				}
			},
			getUUID:function(){
				let url = this.Api.getLastUrl('/uuid');
				this.Api.fetchPost(url).then((data)=>{
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						console.log("000");
					}else{
						
						this.$message.error(msg);
					}
				}).catch((error)=>{
					this.resetLogin(false);
				});
			},
			resetLogin:function(flag){
				this.tipMsg.loadingFlag = false;
				this.tipMsg.loginBtnTip = '登录'; 
				if(flag){
					this.loginForm.userName = '';
					this.loginForm.password = '';
				}
				this.loginForm.code = '';
				this.changeCaptcha();
			}
		},
		mounted() {
			this.changeCaptcha();
		}
	}
</script>
<style>
	.middle {
	    height: calc(100vh);
	    width: 100%;
	    background: no-repeat center top;
	    background-size: cover;
	}
	#title{
		font-family:"Garamond, serif";
		color: #000;
		font-weight: bold;
		font-size: 2.75rem;
		margin:5rem 0rem 0.9375rem 0rem;
		text-align: center;
	}
	#subTitle{
		font-family:"Garamond, serif";
		color: #000;
		font-weight: bold;
		font-size: 2.25rem;
		text-align: center;
	}
	#loginContainer{
		display: flex;
		justify-content: center;
		align-items: center;
		margin-top: 3.125rem;
	}
	#loginDiv{
		border-style: solid;
		border-radius: 0.625rem;
		border-width:0.0625rem;
		border-color:#ffffff;
		background-color:#ffffff;
		width: 22rem;
		height: 14.5rem;
		padding: 0.9375rem 1.25rem  0.9375rem  1.25rem;
		text-align: center;
	}
	#captchaDiv{
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		align-items: center;
	}
	#copyright{
		font-family:"Garamond, serif";
		color: #000;
		font-size: 1.25rem;
		text-align: center;
		position: absolute;
		left: 0rem;
		bottom: 1.25rem;
		width: 100%;
		display: flex;
		justify-content: center;
	}
</style>